<template>
  <el-dialog :title=this.title :visible.sync="innerVisible" custom-class="smini-dialog" center
             :close-on-click-modal="false" :before-close="handleClose"
             append-to-body open>
    <el-form :model="form">
      <el-row :gutter="20">
        <el-col :span="24" style="text-align: center">

          <!--<el-form-item label="公司名称" :label-width="formLabelWidth" prop="printtitle">-->
          <el-table :data="printData" ref="table1"
                    size="mini" border stripe>
            <el-table-column
              prop="value"
              label="公司名称"
              align="center"
              header-align="center"
            >
            </el-table-column>
            <el-table-column
              label="操作"
              align="center" width="80">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="warning"
                  @click="saveData(scope.$index, scope.row)">选择
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <!--<el-radio-group v-model="printtitle">-->
          <!--<el-radio v-for="item in printData" :label="item.value" :key="item.value" border style="display: block;margin-bottom: 5px">-->
          <!--{{item.label}}-->
          <!--</el-radio>-->
          <!--<br/>-->
          <!--</el-radio-group>-->
          <!--</el-form-item>-->

        </el-col>
      </el-row>
    </el-form>
  </el-dialog>
</template>
<script>

  import {saveData, getDetail} from '@/api/set/PriceandKd';
  import {attUUID} from '@/api/attachment';
  import {getParameterDetail} from '@/api/set/parameter';

  export default {
    name: "AddressEdit",
    data() {
      return {
        title: '请选择打印抬头',
        innerVisible: false,
        form: {},
        printData: [],
        printtitle: '',
        formLabelWidth: '120px',
        needreflash: false,
        flage: ''

      }
    },
    methods: {
      handleClose(){
        this.innerVisible = false;
        this.$emit("cancelprint")
      },
      daochu(flage) {
        this.flage = flage
      },
      show(title, needreflash) {
        this.printData = []
        this.printtitle = ''
        this.innerVisible = true;
        if (needreflash)
          this.needreflash = needreflash
        var titles = title.split(";")
        if (title) {
          this.printtitle = titles[0]
          for (let i = 0; i < titles.length; i++) {
            var obj = {}
            obj.value = titles[i]
            obj.label = titles[i]
            this.printData.push(obj)
          }
        }

      },
      saveData(index, row) {
        if (this.flage)
          this.$emit("daochuname", row.value)
        else
          this.$emit("printtitlename", row.value, this.needreflash)

        this.innerVisible = false;
      }
    },
    mounted() {

    },

  }
</script>


<style scoped>
  .titlecolor {
    color: #20A0FF
  }
</style>



// WEBPACK FOOTER //
// src/components/testorder/cstagreement/Printtitle.vue